import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonModule as AppCommonModule } from '@app/common/common.module';
import { PsCommonModule } from '../ps-common.module';
import { ProjectInfoComponent } from './components/project-info/project-info.component';
import { documentClassificationState, documentsToClassifyState, projectInfoState } from './projects.states';
import { UIRouterModule } from '@uirouter/angular';
import { DocumentsToClassifyComponent } from '@app/ps/projects/components/documents-to-classify/documents-to-classify.component';
import { DocumentClassificationComponent } from '@app/ps/projects/components/document-classification/document-classification.component';

const STATES = [
  projectInfoState,
  documentsToClassifyState,
  documentClassificationState,
];

@NgModule({
  declarations: [
    ProjectInfoComponent,
    DocumentsToClassifyComponent,
    DocumentClassificationComponent,
  ],
  entryComponents: [
  ],
  imports: [
    CommonModule,
    AppCommonModule,
    PsCommonModule,
    UIRouterModule.forChild({
      states: [...STATES]
    }),
  ]
})
export class ProjectsModule { }
